<template>
  <div>
    <div>
      <header class="mint-header is-fixed" style="border-bottom: 1px solid gainsboro;background: white;">
        <div style="width: 30rem;height: 32px;" class="mint-search searchstyle">
          <div class="mint-searchbar" style="padding: 0">
            <div class="mint-searchbar-inner">
              <i class="mintui mintui-search"/>
              <input type="search" placeholder="搜索" class="mint-searchbar-core" style="color: black" @focus="Onfocus"/>
              <a class="mint-searchbar-cancel" style="display: none;">取消</a>
            </div>
            <div class="mint-search-list" style="display: none;">
              <div class="mint-search-list-warp"/>
            </div>
          </div>
        </div>
      </header>
    </div>
    <div style="margin-top: 2rem">
      <Tabs>
        <Tab title="唐诗" label="">
          <Tabs>
            <Tab :title="item.type" v-for="item in tangshiTypeList" :key="item.type" label="">
              <Cell style="text-align: left" v-for="item in item.list" :key="item.iD" :title="'《'+item.bT+'》 '+ item.zZ"
                    v-on:click.native="Details(item.iD,item.lB)"/>
              <Cell :title="'共计：'+item.list.length+'首'"/>
            </Tab>
          </Tabs>
        </Tab>
        <Tab title="宋词" label="">
          <Tabs>
            <Tab :title="item.type" v-for="item in songciTypeList" :key="item.type" label="">
              <Cell style="text-align: left" v-for="item in item.list" :key="item.iD" :title="'《'+item.bT+'》 '+ item.zZ"
                    v-on:click.native="Details(item.iD,item.lB)"/>
              <Cell :title="'共计：'+item.list.length+'首'"/>
            </Tab>
          </Tabs>
        </Tab>
        <Tab title="元曲" label="">
          <Tabs>
            <Tab :title="item.type" v-for="item in yuanquTypeList" :key="item.type" label="">
              <Cell style="text-align: left" v-for="item in item.list" :key="item.iD" :title="'《'+item.bT+'》 '+ item.zZ"
                    v-on:click.native="Details(item.iD,item.lB)"/>
              <Cell :title="'共计：'+item.list.length+'首'"/>
            </Tab>
          </Tabs>
        </Tab>
        <Tab title="乐府" label="">
          <Tabs>
            <Tab :title="item.type" v-for="item in yuefuTypeList" :key="item.type" label="">
              <Cell style="text-align: left" v-for="item in item.list" :key="item.iD" :title="'《'+item.mC+'》'"
                    v-on:click.native="Details(item.iD)"/>
              <Cell :title="'共计：'+item.list.length+'首'"/>
            </Tab>
          </Tabs>
        </Tab>
      </Tabs>
    </div>
  </div>
</template>

<script>
import {Tab, Tabs, Cell} from 'vant';
import 'vant/lib/tabs/index.css'
import 'vant/lib/tab/index.css'
import 'vant/lib/cell/index.css'
import {Indicator} from "mint-ui";

export default {
  name: "TangshiSongci",
  mounted() {
    this.getTypeList()
  },
  components: {
    Tab, Tabs, Cell
  },
  data() {
    return {
      yuefuTypeList: [],
      tangshiTypeList: [],
      songciTypeList: [],
      yuanquTypeList: [],
      token: localStorage.getItem('token'),
      getTangshiTypeListUrl: '/api/tangshi/getTypeList',
      getSongciTypeListUrl: '/api/songci/getTypeList',
      getYuanquTypeListUrl: '/api/yuanqu/getTypeList',
      getYueFuTypeListUrl: '/api/yuefu/getTypeList',
      typeModel:
          {
            type: null,
            list: null,
          },
    }
  },
  methods: {
    Onfocus() {
      this.$router.push({name: 'm_shici_search', params: {sigle: '1'}})
    },
    Details(id, lb) {
      let that = this
      if (lb !== undefined)
        that.$router.push({name: 'm_shici_details', params: {id: id, lb: lb}})
      else
        that.$router.push({name: 'm_yuefu_details', params: {id: id}})
    },
    getTypeList() {
      Indicator.open({
        text: '数据加载中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getTangshiTypeListUrl,
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
            if (!response.data.result)
              that.$messagebox.alert(response.data.message)
            else {
              that.tangshiTypeList = response.data['responseData']
            }
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
      that.$ajax({
        method: 'get',
        url: that.getYuanquTypeListUrl,
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
            if (!response.data.result)
              that.$messagebox.alert(response.data.message)
            else {
              that.yuanquTypeList = response.data['responseData']
            }
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
      that.$ajax({
        method: 'get',
        url: that.getSongciTypeListUrl,
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
            //Indicator.close()
            if (!response.data.result)
              that.$messagebox.alert(response.data.message)
            else {
              that.songciTypeList = response.data['responseData']
            }
          }
      ).catch(response => {
        Indicator.close()
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
      that.$ajax({
        method: 'get',
        url: that.getYueFuTypeListUrl,
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
            Indicator.close()
            if (!response.data.result)
              that.$messagebox.alert(response.data.message)
            else {
              that.yuefuTypeList = response.data['responseData']
            }
          }
      ).catch(response => {
        Indicator.close()
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .mint-search {
  height: auto;
}
</style>
